import { render, staticRenderFns } from "./home.vue?vue&type=template&id=8def6cfe&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=8def6cfe&scoped=true&lang=scss&"
import style1 from "./home.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8def6cfe",
  null
  
)

export default component.exports